module.exports = __webpack_public_path__ + "static/media/mil-logo.22ec9c9d.png";